<template>
  <BreadCrumb page="Beranda > Pendaftaran > Assessment > Pengaturan Assessment"></BreadCrumb>
  <div class="container content-area">
    <div class="row">
      <div class="col-12">
        <h3 class="judul-seksi-sga">Pengaturan Assessment PSB Tahun Ajaran {{this.$store.getters.getTahunAJaran}}</h3>
        <LoadSpinner v-if="loading"></LoadSpinner>
        <hr>
        <div class="notes-notification-sga">
          <p><strong>Catatan : </strong></p>
          <ul>
            <li>Masukkan nama anak</li>
            <li>Pilih tanggal</li>
            <li>Sesi #1 : 08.00-09.30</li>
            <li>sesi#2 : 10.15 - 11.45</li>
          </ul>
        </div>
        <form>
          <div class="form-general">
            <div class="row">
              <div class="col-12">
                <h4>Tambah Data</h4>
                <div class="row mb-4">
                  <div class="col-md-11" v-if="messagetrx">
                    <AlertSuccess v-if="successtrx" :message="messagetrx"></AlertSuccess>
                    <AlertDanger v-else :message="messagetrx"></AlertDanger>
                  </div>
                  <div class="col-md-11">
                    <div class="row">
                      <div class="col-md-6 spacer-field-sga">
                        <div class="input-group">
                          <AutoComplete
                              inputClass="w-100 form-control"
                              v-model="selectedSiswa"
                              :suggestions="filteredSiswa"
                              field="namaanak"
                              placeholder="Cari nama anak..."
                              optionLabel="namaanak"
                              @complete="search" />
                        </div>
                        <keterangan-form :class="v$.selectedSiswa.$error?'text-danger':''">Masukkan nama siswa</keterangan-form>
                      </div>
                      <div class="col-md-3 spacer-field-sga">
                        <div class="input-group">
                          <select v-model="tanggal" class="w-100 form-control">
                            <option v-for="(asses,idx) in dataAssesor" :value="asses.id_assessment" :key="idx">{{asses.tanggal}} - {{asses.sesi_waktu}}</option>
                          </select>
                        </div>
                        <keterangan-form :class="v$.tanggal.$error?'text-danger':''">Pilih tanggal</keterangan-form>
                      </div>
                      <div class="col-md-3 button-area-sga text-left">
                        <LoadSpinner v-if="loading"></LoadSpinner>
                        <button v-else type="button" @click="saveDataAssignment" class="btn btn-md btn-success"><i class="fa-solid fa-caret-right"></i>  Tambah data</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table table-striped ">
                    <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Hari</th>
                      <th scope="col">Tanggal</th>
                      <th scope="col">Sesi</th>
                      <th scope="col">Nama Siswa</th>
                      <th scope="col">Nama Orang Tua</th>
                      <th scope="col"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(assesor,idx) in dataAssessmentList" :key="idx">
                      <td scope="row">{{assesor.no}}</td>
                      <td>{{assesor.hari}}</td>
                      <td>{{assesor.tanggal}}</td>
                      <td>{{assesor.sesi_waktu}}</td>
                      <td>{{assesor.anak_nama}}</td>
                      <td>{{assesor.ortu_nama}}</td>
                      <td><a @click="deleteAssignment(assesor.id_assignment)" href="#"><i class="fa-solid fa-trash"></i></a></td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div></div>
            <hr>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import useValidate from '@vuelidate/core'
import BreadCrumb from "@/components/BreadCrumb";
import DashboardServices from "@/services/dashboard.services";
import {required,} from '@vuelidate/validators';
import AlertDanger from "@/components/AlertDanger";
import AlertSuccess from "@/components/AlertSuccess";
import LoadSpinner from "@/components/LoadSpinner";
import AutoComplete from 'primevue/autocomplete';
export default {
  name: "PengaturanAssessment",
  components: {LoadSpinner, AlertSuccess, BreadCrumb,AlertDanger,AutoComplete},
  data:()=>({
    v$: useValidate(),
    loading: false,
    response: '',
    message: '',
    success: false,
    messagetrx: '',
    successtrx: false,
    tanggalkelas:'',
    anggota:'',
    tanggal:'',
    siswa:[],
    selectedSiswa:[],
    filteredSiswa:[],
    dataSiswa:[],
    dataAssesor:[],
    dataAssessmentList:[]
  }),
  methods:{
    search(event) {
      const query = event.query.toLowerCase();
      this.filteredSiswa = this.dataSiswa.filter(item =>
          item.namaanak.toLowerCase().includes(query)
      );
    },
    getDataAssessor(){
      this.loading = true;
      this.$store.commit('loading',this.loading);
      let data = this.lazyParams;
      let path = '/dashboard/getDataAssessment';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.message = response.data.message;
            if(response.data.status===200){
              this.success = true;
              this.dataAssesor = this.response.data;
            }else {
              this.success = false;
            }
            this.loading = false;
            this.$store.commit('loading',this.loading);
          }
      );
    },
    getDataAssessmentList(){
      this.loading = true;
      this.$store.commit('loading',this.loading);
      let data = this.lazyParams;
      let path = '/dashboard/getDataAssessmentSiswa';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.message = response.data.message;
            if(response.data.status===200){
              this.success = true;
              this.dataAssessmentList = this.response.data;
            }else {
              this.success = false;
            }
            this.loading = false;
            this.$store.commit('loading',this.loading);
          }
      );
    },
    async getDataPendaftaran(){
      this.loading = true;
      this.$store.commit('loading',this.loading);
      let data = this.accountData;
      let path = '/dashboard/getDataSiapAssessmentAdmin';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.message = response.data.message;
            if(response.data.status===200){
              this.success = true;
              this.dataSiswa = this.response.data;
            }else {
              this.success = false;
            }
            this.loading = false;
            this.$store.commit('loading',this.loading);
          }
      );
    },
    async saveDataAssignment(){
      const result = await this.v$.$validate();
      if(result){
        this.loading = true;
        this.$store.commit('loading',this.loading);
        let data = {
          tanggal: this.tanggal,
          siswa: this.selectedSiswa
        };
        let path = '/dashboard/simpanAssessmentSiswa';
        DashboardServices.postData(data,path).then(
            (response)=>{
              this.response = response.data;
              this.messagetrx = response.data.message;
              if(response.data.status===200){
                this.successtrx = true;
                this.getDataAssessmentList()

              }else {
                this.successtrx = false;
              }
              this.loading = false;
              this.$store.commit('loading',this.loading);
            }
        );
      }else{
        this.message = 'Silahkan isi data dengan benar';
      }
    },
    deleteAssignment(idAssignment){
      this.loading = true;
      this.$store.commit('loading',this.loading);
      let data = {
        paramname: idAssignment,
        status: 'ACTIVE'
      };
      let path = '/dashboard/deleteAssessmentSiswa';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.messagetrx = response.data.message;
            if(response.data.status===200){
              this.successtrx = true;
              this.getDataAssessor();
              this.getDataAssessmentList();
            }else {
              this.successtrx = false;
            }
            this.loading = false;
            this.$store.commit('loading',this.loading);
          }
      );
    },
  },
  validations(){
    return {
      tanggal:{required},
      selectedSiswa:{required},
    }
  },
  mounted() {
    this.getDataPendaftaran();
    this.getDataAssessor();
    this.getDataAssessmentList();
  }
}
</script>

<style scoped>
.border-b-only {
  border: none;
  border-bottom: 2px dashed #007bff; /* warna biru & garis putus-putus */
  border-radius: 0;
  padding: 8px 4px;
  background-color: transparent;
  outline: none;
}

.border-b-only:focus {
  border-bottom-color: #28a745; /* Warna hijau saat fokus */
  box-shadow: none;
}
</style>